import { DeployTypes } from '../emun/DeployTypes'
import { envEnum, getEnv } from './crossEnv'

export enum EEnvType {
  DEVELOPMENT = 'dev',
  PRODUCTION = 'prod',
  RELEASE_CANDIDATE = 'rc',
}

export const useEnv = (): DeployTypes => {
  const env = getEnv(envEnum.NEXT_PUBLIC_ENVIRONMENT)

  switch (true) {
    case env.startsWith(EEnvType.PRODUCTION):
      return DeployTypes.Production
    case env.startsWith(EEnvType.RELEASE_CANDIDATE):
      return DeployTypes.ReleaseCandidate
    case env.startsWith(EEnvType.DEVELOPMENT):
    default:
      return DeployTypes.Development
  }
}
